export const mockReportsData = {
  model3: {
  "vehicle": {
    "make": "Tesla",
    "model": "Model 3",
    "year": 2022,
    "vin": "5YJ3E1EA8NF123456",
    "type": "EV",
    "region": "EU"
  },
  "vehicleData": {
    "vin": "5YJ3E1EA8NF123456",
    "display_name": "VoltRunner",
    "state": "online",
    "charge_state": {
      "battery_level": 78,
      "battery_range": 237.3,
      "charge_limit_soc": 90,
      "charging_state": "Disconnected"
    },
    "vehicle_state": {
      "car_version": "2024.12.15",
      "odometer": 32450.0,
      "locked": true
    },
    "vehicle_config": {
      "car_type": "model3",
      "trim_badging": "Standard Range Plus",
      "charge_port_type": "CCS"
    }
  },
  "formattedFields": [
    {
      "key": "vehicle.model",
      "label": "Model",
      "value": "Model 3",
      "rawValue": "Model 3",
      "type": "text",
      "section": "identity",
      "panel": "model"
    },
    {
      "key": "vehicle.model_year",
      "label": "Model Year",
      "value": "2022",
      "rawValue": "2022",
      "type": "text",
      "section": "identity",
      "panel": "model"
    },
    {
      "key": "vehicle.vin",
      "label": "VIN",
      "value": "5YJ3E1EA8NF123456",
      "rawValue": "5YJ3E1EA8NF123456",
      "type": "text",
      "section": "identity",
      "panel": "registration",
      "mono": true
    },
    {
      "key": "vehicle.region",
      "label": "Region",
      "value": "EU",
      "rawValue": "EU",
      "type": "text",
      "section": "identity",
      "panel": "ids"
    },
    {
      "key": "vehicle_state.locked",
      "label": "Locked",
      "value": "Yes",
      "rawValue": "Yes",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.sentry_mode",
      "label": "Sentry Mode",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.vehicle_name",
      "label": "Vehicle Name",
      "value": "VoltRunner",
      "rawValue": "VoltRunner",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.dashcam_state",
      "label": "Dashcam State",
      "value": "Recording",
      "rawValue": "Recording",
      "type": "text",
      "section": "state",
      "panel": "controls"
    },
    {
      "key": "vehicle_state.tpms_pressure_fl",
      "label": "TPMS FL",
      "value": "2.9 bar",
      "rawValue": "2.9 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_fr",
      "label": "TPMS FR",
      "value": "2.8 bar",
      "rawValue": "2.8 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_rl",
      "label": "TPMS RL",
      "value": "3.0 bar",
      "rawValue": "3.0 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_rr",
      "label": "TPMS RR",
      "value": "3.1 bar",
      "rawValue": "3.1 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.webcam_available",
      "label": "Webcam Available",
      "value": "Yes",
      "rawValue": "Yes",
      "type": "text",
      "section": "state",
      "panel": "camera_tokens"
    },
    {
      "key": "vehicle_state.service_mode",
      "label": "Service Mode",
      "value": "Inactive",
      "rawValue": "Inactive",
      "type": "text",
      "section": "state",
      "panel": "access_service"
    },
    {
      "key": "vehicle_state.fd_window",
      "label": "Front Driver Window",
      "value": "Closed",
      "rawValue": "Closed",
      "type": "text",
      "section": "state",
      "panel": "windows"
    },
    {
      "key": "climate_state.inside_temp",
      "label": "Inside Temp",
      "value": "21.5 C",
      "rawValue": "21.5 C",
      "type": "text",
      "section": "climate",
      "panel": "temperature"
    },
    {
      "key": "climate_state.outside_temp",
      "label": "Outside Temp",
      "value": "15.0 C",
      "rawValue": "15.0 C",
      "type": "text",
      "section": "climate",
      "panel": "temperature"
    },
    {
      "key": "climate_state.climate_keeper_mode",
      "label": "Climate Keeper",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "climate",
      "panel": "systems"
    },
    {
      "key": "climate_state.steering_wheel_heater",
      "label": "Steering Wheel Heater",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "climate",
      "panel": "seats"
    },
    {
      "key": "vehicle_state.media_info",
      "label": "Media Activity",
      "value": "Idle",
      "rawValue": "Idle",
      "type": "text",
      "section": "media",
      "panel": "playback"
    },
    {
      "key": "charge_state.battery_level",
      "label": "Battery Level",
      "value": "78%",
      "rawValue": "78%",
      "type": "text",
      "section": "battery",
      "panel": "health"
    },
    {
      "key": "charge_state.battery_range",
      "label": "Rated Range",
      "value": "382.0 km",
      "rawValue": "382.0 km",
      "type": "text",
      "section": "battery",
      "panel": "range"
    },
    {
      "key": "battery_summary.outlook",
      "label": "Battery Outlook",
      "value": "Excellent",
      "rawValue": "Excellent",
      "type": "text",
      "section": "battery",
      "panel": "condition"
    },
    {
      "key": "charge_state.charging_state",
      "label": "Charging State",
      "value": "Disconnected",
      "rawValue": "Disconnected",
      "type": "text",
      "section": "charging",
      "panel": "current_session"
    },
    {
      "key": "charge_state.charger_power",
      "label": "Charge Power",
      "value": "0 kW",
      "rawValue": "0 kW",
      "type": "text",
      "section": "charging",
      "panel": "electrical"
    },
    {
      "key": "charge_state.charge_port_latch",
      "label": "Charge Port Latch",
      "value": "Closed",
      "rawValue": "Closed",
      "type": "text",
      "section": "charging",
      "panel": "hardware"
    },
    {
      "key": "charge_state.off_peak_charging_enabled",
      "label": "Off-Peak Charging",
      "value": "Enabled",
      "rawValue": "Enabled",
      "type": "text",
      "section": "charging",
      "panel": "schedule"
    },
    {
      "key": "vehicle_config.exterior_color",
      "label": "Exterior Color",
      "value": "Pearl White",
      "rawValue": "Pearl White",
      "type": "text",
      "section": "specs",
      "panel": "exterior"
    },
    {
      "key": "vehicle_config.wheel_type",
      "label": "Wheel Type",
      "value": "18\" Aero",
      "rawValue": "18\" Aero",
      "type": "text",
      "section": "specs",
      "panel": "exterior"
    },
    {
      "key": "vehicle_config.charge_port_type",
      "label": "Charge Port",
      "value": "CCS (Type 2)",
      "rawValue": "CCS (Type 2)",
      "type": "text",
      "section": "specs",
      "panel": "hardware_drive"
    },
    {
      "key": "vehicle_config.has_seat_cooling",
      "label": "Seat Cooling",
      "value": "No",
      "rawValue": "No",
      "type": "text",
      "section": "specs",
      "panel": "capabilities"
    },
    {
      "key": "vehicle_config.trim_badging",
      "label": "Trim Badging",
      "value": "Standard Range Plus",
      "rawValue": "Standard Range Plus",
      "type": "text",
      "section": "specs",
      "panel": "cabin"
    },
    {
      "key": "gui_settings.gui_distance_units",
      "label": "Distance Units",
      "value": "km",
      "rawValue": "km",
      "type": "text",
      "section": "specs",
      "panel": "settings"
    },
    {
      "key": "vehicle_config.utc_offset",
      "label": "UTC Offset",
      "value": "+2",
      "rawValue": "+2",
      "type": "text",
      "section": "specs",
      "panel": "region_platform"
    },
    {
      "key": "vehicle_state.software_update.status",
      "label": "Update Status",
      "value": "Up to date",
      "rawValue": "Up to date",
      "type": "text",
      "section": "specs",
      "panel": "software"
    },
    {
      "key": "vehicle_state.car_version",
      "label": "Installed Version",
      "value": "2024.12.15",
      "rawValue": "2024.12.15",
      "type": "text",
      "section": "specs",
      "panel": "software"
    }
  ],
  "batterySummary": {
    "batterySoh": "94%",
    "batteryCapacityKwh": "57.5 kWh",
    "estimatedRangeKm": 382.0
  },
  "chargingSummary": {
    "sessionCount": 186,
    "acRatio": "92%"
  },
  "alertSummary": {
    "totalCount": 1,
    "chargingAlertCount": 0
  },
  "warrantySummary": {
    "coverageCount": 2,
    "nearestExpirationDate": "2030-06-15T00:00:00Z"
  },
  "projection": {
    "result": {
      "degradationRatePer1000km": 0.08,
      "estimatedSoh": "94.2%",
      "projectedKmToWarrantyFloor": 280000,
      "rangeReductionKm": 24.0
    }
  }
},
  modely: {
  "vehicle": {
    "make": "Tesla",
    "model": "Model Y",
    "year": 2023,
    "vin": "5YJYG1EE8PF987654",
    "type": "EV",
    "region": "EU"
  },
  "vehicleData": {
    "vin": "5YJYG1EE8PF987654",
    "display_name": "Y-Cruiser",
    "state": "online",
    "charge_state": {
      "battery_level": 88,
      "battery_range": 435.5,
      "charge_limit_soc": 90,
      "charging_state": "Disconnected"
    },
    "vehicle_state": {
      "car_version": "2024.12.15",
      "odometer": 18120.0,
      "locked": true
    },
    "vehicle_config": {
      "car_type": "modely",
      "trim_badging": "Long Range AWD",
      "charge_port_type": "CCS"
    }
  },
  "formattedFields": [
    {
      "key": "vehicle.model",
      "label": "Model",
      "value": "Model Y",
      "rawValue": "Model 3",
      "type": "text",
      "section": "identity",
      "panel": "model"
    },
    {
      "key": "vehicle.model_year",
      "label": "Model Year",
      "value": "2023",
      "rawValue": "2022",
      "type": "text",
      "section": "identity",
      "panel": "model"
    },
    {
      "key": "vehicle.vin",
      "label": "VIN",
      "value": "5YJYG1EE8PF987654",
      "rawValue": "5YJ3E1EA8NF123456",
      "type": "text",
      "section": "identity",
      "panel": "registration",
      "mono": true
    },
    {
      "key": "vehicle.region",
      "label": "Region",
      "value": "EU",
      "rawValue": "EU",
      "type": "text",
      "section": "identity",
      "panel": "ids"
    },
    {
      "key": "vehicle_state.locked",
      "label": "Locked",
      "value": "Yes",
      "rawValue": "Yes",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.sentry_mode",
      "label": "Sentry Mode",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.vehicle_name",
      "label": "Vehicle Name",
      "value": "VoltRunner",
      "rawValue": "VoltRunner",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.dashcam_state",
      "label": "Dashcam State",
      "value": "Recording",
      "rawValue": "Recording",
      "type": "text",
      "section": "state",
      "panel": "controls"
    },
    {
      "key": "vehicle_state.tpms_pressure_fl",
      "label": "TPMS FL",
      "value": "2.9 bar",
      "rawValue": "2.9 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_fr",
      "label": "TPMS FR",
      "value": "2.8 bar",
      "rawValue": "2.8 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_rl",
      "label": "TPMS RL",
      "value": "3.0 bar",
      "rawValue": "3.0 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_rr",
      "label": "TPMS RR",
      "value": "3.1 bar",
      "rawValue": "3.1 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.webcam_available",
      "label": "Webcam Available",
      "value": "Yes",
      "rawValue": "Yes",
      "type": "text",
      "section": "state",
      "panel": "camera_tokens"
    },
    {
      "key": "vehicle_state.service_mode",
      "label": "Service Mode",
      "value": "Inactive",
      "rawValue": "Inactive",
      "type": "text",
      "section": "state",
      "panel": "access_service"
    },
    {
      "key": "vehicle_state.fd_window",
      "label": "Front Driver Window",
      "value": "Closed",
      "rawValue": "Closed",
      "type": "text",
      "section": "state",
      "panel": "windows"
    },
    {
      "key": "climate_state.inside_temp",
      "label": "Inside Temp",
      "value": "21.5 C",
      "rawValue": "21.5 C",
      "type": "text",
      "section": "climate",
      "panel": "temperature"
    },
    {
      "key": "climate_state.outside_temp",
      "label": "Outside Temp",
      "value": "15.0 C",
      "rawValue": "15.0 C",
      "type": "text",
      "section": "climate",
      "panel": "temperature"
    },
    {
      "key": "climate_state.climate_keeper_mode",
      "label": "Climate Keeper",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "climate",
      "panel": "systems"
    },
    {
      "key": "climate_state.steering_wheel_heater",
      "label": "Steering Wheel Heater",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "climate",
      "panel": "seats"
    },
    {
      "key": "vehicle_state.media_info",
      "label": "Media Activity",
      "value": "Idle",
      "rawValue": "Idle",
      "type": "text",
      "section": "media",
      "panel": "playback"
    },
    {
      "key": "charge_state.battery_level",
      "label": "Battery Level",
      "value": "78%",
      "rawValue": "78%",
      "type": "text",
      "section": "battery",
      "panel": "health"
    },
    {
      "key": "charge_state.battery_range",
      "label": "Rated Range",
      "value": "495.0 km",
      "rawValue": "382.0 km",
      "type": "text",
      "section": "battery",
      "panel": "range"
    },
    {
      "key": "battery_summary.outlook",
      "label": "Battery Outlook",
      "value": "Excellent",
      "rawValue": "Excellent",
      "type": "text",
      "section": "battery",
      "panel": "condition"
    },
    {
      "key": "charge_state.charging_state",
      "label": "Charging State",
      "value": "Disconnected",
      "rawValue": "Disconnected",
      "type": "text",
      "section": "charging",
      "panel": "current_session"
    },
    {
      "key": "charge_state.charger_power",
      "label": "Charge Power",
      "value": "0 kW",
      "rawValue": "0 kW",
      "type": "text",
      "section": "charging",
      "panel": "electrical"
    },
    {
      "key": "charge_state.charge_port_latch",
      "label": "Charge Port Latch",
      "value": "Closed",
      "rawValue": "Closed",
      "type": "text",
      "section": "charging",
      "panel": "hardware"
    },
    {
      "key": "charge_state.off_peak_charging_enabled",
      "label": "Off-Peak Charging",
      "value": "Enabled",
      "rawValue": "Enabled",
      "type": "text",
      "section": "charging",
      "panel": "schedule"
    },
    {
      "key": "vehicle_config.exterior_color",
      "label": "Exterior Color",
      "value": "Midnight Silver",
      "rawValue": "Pearl White",
      "type": "text",
      "section": "specs",
      "panel": "exterior"
    },
    {
      "key": "vehicle_config.wheel_type",
      "label": "Wheel Type",
      "value": "19\" Gemini",
      "rawValue": "18\" Aero",
      "type": "text",
      "section": "specs",
      "panel": "exterior"
    },
    {
      "key": "vehicle_config.charge_port_type",
      "label": "Charge Port",
      "value": "CCS (Type 2)",
      "rawValue": "CCS (Type 2)",
      "type": "text",
      "section": "specs",
      "panel": "hardware_drive"
    },
    {
      "key": "vehicle_config.has_seat_cooling",
      "label": "Seat Cooling",
      "value": "No",
      "rawValue": "No",
      "type": "text",
      "section": "specs",
      "panel": "capabilities"
    },
    {
      "key": "vehicle_config.trim_badging",
      "label": "Trim Badging",
      "value": "Long Range AWD",
      "rawValue": "Standard Range Plus",
      "type": "text",
      "section": "specs",
      "panel": "cabin"
    },
    {
      "key": "gui_settings.gui_distance_units",
      "label": "Distance Units",
      "value": "km",
      "rawValue": "km",
      "type": "text",
      "section": "specs",
      "panel": "settings"
    },
    {
      "key": "vehicle_config.utc_offset",
      "label": "UTC Offset",
      "value": "+2",
      "rawValue": "+2",
      "type": "text",
      "section": "specs",
      "panel": "region_platform"
    },
    {
      "key": "vehicle_state.software_update.status",
      "label": "Update Status",
      "value": "Up to date",
      "rawValue": "Up to date",
      "type": "text",
      "section": "specs",
      "panel": "software"
    },
    {
      "key": "vehicle_state.car_version",
      "label": "Installed Version",
      "value": "2024.12.15",
      "rawValue": "2024.12.15",
      "type": "text",
      "section": "specs",
      "panel": "software"
    }
  ],
  "batterySummary": {
    "batterySoh": "97%",
    "batteryCapacityKwh": "75.0 kWh",
    "estimatedRangeKm": 495.0
  },
  "chargingSummary": {
    "sessionCount": 94,
    "acRatio": "65%"
  },
  "alertSummary": {
    "totalCount": 0,
    "chargingAlertCount": 0
  },
  "warrantySummary": {
    "coverageCount": 2,
    "nearestExpirationDate": "2031-09-12T00:00:00Z"
  },
  "projection": {
    "result": {
      "degradationRatePer1000km": 0.06,
      "estimatedSoh": "97.4%",
      "projectedKmToWarrantyFloor": 320000,
      "rangeReductionKm": 15.0
    }
  }
},
  models: {
  "vehicle": {
    "make": "Tesla",
    "model": "Model S",
    "year": 2021,
    "vin": "5YJSA1E18MF555555",
    "type": "EV",
    "region": "EU"
  },
  "vehicleData": {
    "vin": "5YJSA1E18MF555555",
    "display_name": "PlaidSpace",
    "state": "online",
    "charge_state": {
      "battery_level": 62,
      "battery_range": 336.0,
      "charge_limit_soc": 80,
      "charging_state": "Disconnected"
    },
    "vehicle_state": {
      "car_version": "2024.12.15",
      "odometer": 84200.0,
      "locked": true
    },
    "vehicle_config": {
      "car_type": "models",
      "trim_badging": "Plaid",
      "charge_port_type": "CCS"
    }
  },
  "formattedFields": [
    {
      "key": "vehicle.model",
      "label": "Model",
      "value": "Model S",
      "rawValue": "Model 3",
      "type": "text",
      "section": "identity",
      "panel": "model"
    },
    {
      "key": "vehicle.model_year",
      "label": "Model Year",
      "value": "2021",
      "rawValue": "2022",
      "type": "text",
      "section": "identity",
      "panel": "model"
    },
    {
      "key": "vehicle.vin",
      "label": "VIN",
      "value": "5YJSA1E18MF555555",
      "rawValue": "5YJ3E1EA8NF123456",
      "type": "text",
      "section": "identity",
      "panel": "registration",
      "mono": true
    },
    {
      "key": "vehicle.region",
      "label": "Region",
      "value": "EU",
      "rawValue": "EU",
      "type": "text",
      "section": "identity",
      "panel": "ids"
    },
    {
      "key": "vehicle_state.locked",
      "label": "Locked",
      "value": "Yes",
      "rawValue": "Yes",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.sentry_mode",
      "label": "Sentry Mode",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.vehicle_name",
      "label": "Vehicle Name",
      "value": "VoltRunner",
      "rawValue": "VoltRunner",
      "type": "text",
      "section": "state",
      "panel": "security"
    },
    {
      "key": "vehicle_state.dashcam_state",
      "label": "Dashcam State",
      "value": "Recording",
      "rawValue": "Recording",
      "type": "text",
      "section": "state",
      "panel": "controls"
    },
    {
      "key": "vehicle_state.tpms_pressure_fl",
      "label": "TPMS FL",
      "value": "2.9 bar",
      "rawValue": "2.9 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_fr",
      "label": "TPMS FR",
      "value": "2.8 bar",
      "rawValue": "2.8 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_rl",
      "label": "TPMS RL",
      "value": "3.0 bar",
      "rawValue": "3.0 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.tpms_pressure_rr",
      "label": "TPMS RR",
      "value": "3.1 bar",
      "rawValue": "3.1 bar",
      "type": "text",
      "section": "state",
      "panel": "diagnostics"
    },
    {
      "key": "vehicle_state.webcam_available",
      "label": "Webcam Available",
      "value": "Yes",
      "rawValue": "Yes",
      "type": "text",
      "section": "state",
      "panel": "camera_tokens"
    },
    {
      "key": "vehicle_state.service_mode",
      "label": "Service Mode",
      "value": "Inactive",
      "rawValue": "Inactive",
      "type": "text",
      "section": "state",
      "panel": "access_service"
    },
    {
      "key": "vehicle_state.fd_window",
      "label": "Front Driver Window",
      "value": "Closed",
      "rawValue": "Closed",
      "type": "text",
      "section": "state",
      "panel": "windows"
    },
    {
      "key": "climate_state.inside_temp",
      "label": "Inside Temp",
      "value": "21.5 C",
      "rawValue": "21.5 C",
      "type": "text",
      "section": "climate",
      "panel": "temperature"
    },
    {
      "key": "climate_state.outside_temp",
      "label": "Outside Temp",
      "value": "15.0 C",
      "rawValue": "15.0 C",
      "type": "text",
      "section": "climate",
      "panel": "temperature"
    },
    {
      "key": "climate_state.climate_keeper_mode",
      "label": "Climate Keeper",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "climate",
      "panel": "systems"
    },
    {
      "key": "climate_state.steering_wheel_heater",
      "label": "Steering Wheel Heater",
      "value": "Off",
      "rawValue": "Off",
      "type": "text",
      "section": "climate",
      "panel": "seats"
    },
    {
      "key": "vehicle_state.media_info",
      "label": "Media Activity",
      "value": "Idle",
      "rawValue": "Idle",
      "type": "text",
      "section": "media",
      "panel": "playback"
    },
    {
      "key": "charge_state.battery_level",
      "label": "Battery Level",
      "value": "78%",
      "rawValue": "78%",
      "type": "text",
      "section": "battery",
      "panel": "health"
    },
    {
      "key": "charge_state.battery_range",
      "label": "Rated Range",
      "value": "542.0 km",
      "rawValue": "382.0 km",
      "type": "text",
      "section": "battery",
      "panel": "range"
    },
    {
      "key": "battery_summary.outlook",
      "label": "Battery Outlook",
      "value": "Good",
      "rawValue": "Excellent",
      "type": "text",
      "section": "battery",
      "panel": "condition"
    },
    {
      "key": "charge_state.charging_state",
      "label": "Charging State",
      "value": "Disconnected",
      "rawValue": "Disconnected",
      "type": "text",
      "section": "charging",
      "panel": "current_session"
    },
    {
      "key": "charge_state.charger_power",
      "label": "Charge Power",
      "value": "0 kW",
      "rawValue": "0 kW",
      "type": "text",
      "section": "charging",
      "panel": "electrical"
    },
    {
      "key": "charge_state.charge_port_latch",
      "label": "Charge Port Latch",
      "value": "Closed",
      "rawValue": "Closed",
      "type": "text",
      "section": "charging",
      "panel": "hardware"
    },
    {
      "key": "charge_state.off_peak_charging_enabled",
      "label": "Off-Peak Charging",
      "value": "Enabled",
      "rawValue": "Enabled",
      "type": "text",
      "section": "charging",
      "panel": "schedule"
    },
    {
      "key": "vehicle_config.exterior_color",
      "label": "Exterior Color",
      "value": "Solid Black",
      "rawValue": "Pearl White",
      "type": "text",
      "section": "specs",
      "panel": "exterior"
    },
    {
      "key": "vehicle_config.wheel_type",
      "label": "Wheel Type",
      "value": "21\" Arachnid",
      "rawValue": "18\" Aero",
      "type": "text",
      "section": "specs",
      "panel": "exterior"
    },
    {
      "key": "vehicle_config.charge_port_type",
      "label": "Charge Port",
      "value": "CCS (Type 2)",
      "rawValue": "CCS (Type 2)",
      "type": "text",
      "section": "specs",
      "panel": "hardware_drive"
    },
    {
      "key": "vehicle_config.has_seat_cooling",
      "label": "Seat Cooling",
      "value": "No",
      "rawValue": "No",
      "type": "text",
      "section": "specs",
      "panel": "capabilities"
    },
    {
      "key": "vehicle_config.trim_badging",
      "label": "Trim Badging",
      "value": "Plaid",
      "rawValue": "Standard Range Plus",
      "type": "text",
      "section": "specs",
      "panel": "cabin"
    },
    {
      "key": "gui_settings.gui_distance_units",
      "label": "Distance Units",
      "value": "km",
      "rawValue": "km",
      "type": "text",
      "section": "specs",
      "panel": "settings"
    },
    {
      "key": "vehicle_config.utc_offset",
      "label": "UTC Offset",
      "value": "+2",
      "rawValue": "+2",
      "type": "text",
      "section": "specs",
      "panel": "region_platform"
    },
    {
      "key": "vehicle_state.software_update.status",
      "label": "Update Status",
      "value": "Up to date",
      "rawValue": "Up to date",
      "type": "text",
      "section": "specs",
      "panel": "software"
    },
    {
      "key": "vehicle_state.car_version",
      "label": "Installed Version",
      "value": "2024.12.15",
      "rawValue": "2024.12.15",
      "type": "text",
      "section": "specs",
      "panel": "software"
    }
  ],
  "batterySummary": {
    "batterySoh": "89%",
    "batteryCapacityKwh": "95.0 kWh",
    "estimatedRangeKm": 542.0
  },
  "chargingSummary": {
    "sessionCount": 412,
    "acRatio": "45%"
  },
  "alertSummary": {
    "totalCount": 3,
    "chargingAlertCount": 1
  },
  "warrantySummary": {
    "coverageCount": 2,
    "nearestExpirationDate": "2029-11-30T00:00:00Z"
  },
  "projection": {
    "result": {
      "degradationRatePer1000km": 0.13,
      "estimatedSoh": "88.9%",
      "projectedKmToWarrantyFloor": 195000,
      "rangeReductionKm": 67.0
    }
  },
  "chargingHistory": [
    { "sessionId": 701001001, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2026-06-20T09:14:00+03:00", "chargeStopDateTime": "2026-06-20T09:52:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [{ "fileName": "invoice_701001001.pdf", "contentId": "inv-fi-2026-06-20-001", "invoiceType": "CHARGING" }], "fees": [{ "sessionFeeId": 1, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 47.2, "totalDue": 17.94, "netDue": 17.94, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 700882341, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-06-16T22:05:00+03:00", "chargeStopDateTime": "2026-06-17T05:30:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 700654123, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2026-06-10T13:22:00+03:00", "chargeStopDateTime": "2026-06-10T14:01:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [{ "fileName": "invoice_700654123.pdf", "contentId": "inv-fi-2026-06-10-002", "invoiceType": "CHARGING" }], "fees": [{ "sessionFeeId": 2, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 53.8, "totalDue": 20.44, "netDue": 20.44, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 700412988, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-06-06T23:10:00+03:00", "chargeStopDateTime": "2026-06-07T06:00:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 700198765, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2026-06-01T11:45:00+03:00", "chargeStopDateTime": "2026-06-01T12:28:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [{ "fileName": "invoice_700198765.pdf", "contentId": "inv-fi-2026-06-01-003", "invoiceType": "CHARGING" }], "fees": [{ "sessionFeeId": 3, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 61.4, "totalDue": 23.33, "netDue": 23.33, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 699876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-05-27T21:45:00+03:00", "chargeStopDateTime": "2026-05-28T04:20:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 699543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Stockholm Kungens Kurva", "chargeStartDateTime": "2026-05-21T10:30:00+02:00", "chargeStopDateTime": "2026-05-21T11:18:00+02:00", "countryCode": "SE", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [{ "fileName": "invoice_699543210.pdf", "contentId": "inv-se-2026-05-21-004", "invoiceType": "CHARGING" }], "fees": [{ "sessionFeeId": 4, "feeType": "CHARGING", "currencyCode": "SEK", "pricingType": "PER_KWH", "rateBase": 4.20, "usageBase": 72.1, "totalDue": 302.82, "netDue": 302.82, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 699210987, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Stockholm Kungens Kurva", "chargeStartDateTime": "2026-05-19T16:10:00+02:00", "chargeStopDateTime": "2026-05-19T16:48:00+02:00", "countryCode": "SE", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 5, "feeType": "CHARGING", "currencyCode": "SEK", "pricingType": "PER_KWH", "rateBase": 4.20, "usageBase": 44.6, "totalDue": 187.32, "netDue": 187.32, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 698876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-05-13T22:30:00+03:00", "chargeStopDateTime": "2026-05-14T05:15:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 698543876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2026-05-07T08:55:00+03:00", "chargeStopDateTime": "2026-05-07T09:38:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 6, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 55.9, "totalDue": 21.24, "netDue": 21.24, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 698210543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-05-02T23:00:00+03:00", "chargeStopDateTime": "2026-05-03T05:45:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 697876210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2026-04-26T12:10:00+03:00", "chargeStopDateTime": "2026-04-26T12:54:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 7, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 66.3, "totalDue": 25.19, "netDue": 25.19, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 697543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-04-20T21:55:00+03:00", "chargeStopDateTime": "2026-04-21T04:30:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 697210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Oslo Alnabru", "chargeStartDateTime": "2026-04-14T09:20:00+02:00", "chargeStopDateTime": "2026-04-14T10:05:00+02:00", "countryCode": "NO", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [{ "fileName": "invoice_697210876.pdf", "contentId": "inv-no-2026-04-14-005", "invoiceType": "CHARGING" }], "fees": [{ "sessionFeeId": 8, "feeType": "CHARGING", "currencyCode": "NOK", "pricingType": "PER_KWH", "rateBase": 4.50, "usageBase": 68.7, "totalDue": 309.15, "netDue": 309.15, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 696876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Oslo Alnabru", "chargeStartDateTime": "2026-04-12T15:40:00+02:00", "chargeStopDateTime": "2026-04-12T16:18:00+02:00", "countryCode": "NO", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 9, "feeType": "CHARGING", "currencyCode": "NOK", "pricingType": "PER_KWH", "rateBase": 4.50, "usageBase": 42.3, "totalDue": 190.35, "netDue": 190.35, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 696543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-04-06T22:10:00+03:00", "chargeStopDateTime": "2026-04-07T05:00:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 696210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2026-03-31T11:05:00+03:00", "chargeStopDateTime": "2026-03-31T11:52:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 10, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 58.4, "totalDue": 22.19, "netDue": 22.19, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 695876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-03-24T23:00:00+02:00", "chargeStopDateTime": "2026-03-25T05:45:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 695543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Copenhagen Ørestad", "chargeStartDateTime": "2026-03-18T10:15:00+01:00", "chargeStopDateTime": "2026-03-18T11:02:00+01:00", "countryCode": "DK", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 11, "feeType": "CHARGING", "currencyCode": "DKK", "pricingType": "PER_KWH", "rateBase": 3.20, "usageBase": 70.2, "totalDue": 224.64, "netDue": 224.64, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 695210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-03-12T22:30:00+02:00", "chargeStopDateTime": "2026-03-13T05:15:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 694876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2026-03-05T13:40:00+02:00", "chargeStopDateTime": "2026-03-05T14:24:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 12, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 63.1, "totalDue": 23.98, "netDue": 23.98, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 694543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-02-26T21:55:00+02:00", "chargeStopDateTime": "2026-02-27T04:40:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 694210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2026-02-19T09:05:00+02:00", "chargeStopDateTime": "2026-02-19T09:51:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 13, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 69.8, "totalDue": 27.92, "netDue": 27.92, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 693876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-02-12T22:20:00+02:00", "chargeStopDateTime": "2026-02-13T05:05:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 693543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2026-02-05T12:30:00+02:00", "chargeStopDateTime": "2026-02-05T13:18:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 14, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 74.5, "totalDue": 29.80, "netDue": 29.80, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 693210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-01-28T23:10:00+02:00", "chargeStopDateTime": "2026-01-29T06:00:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 692876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2026-01-21T10:45:00+02:00", "chargeStopDateTime": "2026-01-21T11:35:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 15, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 78.2, "totalDue": 31.28, "netDue": 31.28, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 692543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2026-01-14T22:45:00+02:00", "chargeStopDateTime": "2026-01-15T05:30:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 692210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2026-01-07T08:20:00+02:00", "chargeStopDateTime": "2026-01-07T09:10:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 16, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 80.1, "totalDue": 32.04, "netDue": 32.04, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 691876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-12-28T23:00:00+02:00", "chargeStopDateTime": "2025-12-29T05:45:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 691543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2025-12-20T11:30:00+02:00", "chargeStopDateTime": "2025-12-20T12:22:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 17, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 76.4, "totalDue": 30.56, "netDue": 30.56, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 691210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-12-13T22:15:00+02:00", "chargeStopDateTime": "2025-12-14T05:00:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 690876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Berlin Tempelhofer Damm", "chargeStartDateTime": "2025-12-05T14:20:00+01:00", "chargeStopDateTime": "2025-12-05T15:08:00+01:00", "countryCode": "DE", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 18, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.42, "usageBase": 65.3, "totalDue": 27.43, "netDue": 27.43, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 690543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Berlin Tempelhofer Damm", "chargeStartDateTime": "2025-12-03T09:45:00+01:00", "chargeStopDateTime": "2025-12-03T10:28:00+01:00", "countryCode": "DE", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 19, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.42, "usageBase": 48.7, "totalDue": 20.45, "netDue": 20.45, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 690210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-11-25T22:40:00+02:00", "chargeStopDateTime": "2025-11-26T05:25:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 689876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2025-11-17T10:55:00+02:00", "chargeStopDateTime": "2025-11-17T11:45:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 20, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 72.8, "totalDue": 27.66, "netDue": 27.66, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 689543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-11-10T23:05:00+02:00", "chargeStopDateTime": "2025-11-11T05:50:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 689210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2025-11-03T09:10:00+02:00", "chargeStopDateTime": "2025-11-03T09:58:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 21, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 67.5, "totalDue": 25.65, "netDue": 25.65, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 688876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-10-26T22:50:00+03:00", "chargeStopDateTime": "2025-10-27T05:35:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 688543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2025-10-18T12:20:00+03:00", "chargeStopDateTime": "2025-10-18T13:10:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 22, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 71.2, "totalDue": 27.06, "netDue": 27.06, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 688210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-10-11T23:00:00+03:00", "chargeStopDateTime": "2025-10-12T05:45:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 687876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2025-10-03T11:15:00+03:00", "chargeStopDateTime": "2025-10-03T12:05:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 23, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 64.8, "totalDue": 24.62, "netDue": 24.62, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 687543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-09-24T22:20:00+03:00", "chargeStopDateTime": "2025-09-25T05:10:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 687210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Gothenburg Sisjön", "chargeStartDateTime": "2025-09-16T10:30:00+02:00", "chargeStopDateTime": "2025-09-16T11:20:00+02:00", "countryCode": "SE", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 24, "feeType": "CHARGING", "currencyCode": "SEK", "pricingType": "PER_KWH", "rateBase": 4.20, "usageBase": 69.4, "totalDue": 291.48, "netDue": 291.48, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 686876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-09-08T22:45:00+03:00", "chargeStopDateTime": "2025-09-09T05:30:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 686543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2025-09-01T13:05:00+03:00", "chargeStopDateTime": "2025-09-01T13:52:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 25, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 59.6, "totalDue": 22.65, "netDue": 22.65, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 686210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-08-24T21:50:00+03:00", "chargeStopDateTime": "2025-08-25T04:35:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 685876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2025-08-16T09:40:00+03:00", "chargeStopDateTime": "2025-08-16T10:28:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 26, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 62.3, "totalDue": 22.43, "netDue": 22.43, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 685543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-08-08T23:15:00+03:00", "chargeStopDateTime": "2025-08-09T06:00:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 685210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2025-07-31T12:50:00+03:00", "chargeStopDateTime": "2025-07-31T13:38:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 27, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 57.9, "totalDue": 20.84, "netDue": 20.84, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 684876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-07-22T22:30:00+03:00", "chargeStopDateTime": "2025-07-23T05:15:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 684543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2025-07-14T10:20:00+03:00", "chargeStopDateTime": "2025-07-14T11:08:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 28, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 66.7, "totalDue": 24.01, "netDue": 24.01, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 684210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-07-06T23:00:00+03:00", "chargeStopDateTime": "2025-07-07T05:45:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 683876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2025-06-28T11:35:00+03:00", "chargeStopDateTime": "2025-06-28T12:22:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 29, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 60.2, "totalDue": 21.67, "netDue": 21.67, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 683543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-06-20T22:10:00+03:00", "chargeStopDateTime": "2025-06-21T04:55:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 683210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2025-06-13T08:50:00+03:00", "chargeStopDateTime": "2025-06-13T09:38:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 30, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 55.4, "totalDue": 19.94, "netDue": 19.94, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 682876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-06-05T23:20:00+03:00", "chargeStopDateTime": "2025-06-06T06:05:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 682543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2025-05-27T12:00:00+03:00", "chargeStopDateTime": "2025-05-27T12:48:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 31, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 68.9, "totalDue": 24.80, "netDue": 24.80, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 682210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-05-19T22:45:00+03:00", "chargeStopDateTime": "2025-05-20T05:30:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 681876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2025-05-11T10:05:00+03:00", "chargeStopDateTime": "2025-05-11T10:55:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 32, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 73.1, "totalDue": 26.32, "netDue": 26.32, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 681543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-05-03T23:10:00+03:00", "chargeStopDateTime": "2025-05-04T05:55:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 681210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2025-04-25T13:30:00+03:00", "chargeStopDateTime": "2025-04-25T14:18:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 33, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 63.7, "totalDue": 22.93, "netDue": 22.93, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 680876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-04-17T22:25:00+03:00", "chargeStopDateTime": "2025-04-18T05:10:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 680543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2025-04-09T09:00:00+03:00", "chargeStopDateTime": "2025-04-09T09:48:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 34, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 70.5, "totalDue": 25.38, "netDue": 25.38, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 680210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-04-01T22:50:00+03:00", "chargeStopDateTime": "2025-04-02T05:35:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 679876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2025-03-24T11:40:00+02:00", "chargeStopDateTime": "2025-03-24T12:28:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 35, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 75.8, "totalDue": 27.29, "netDue": 27.29, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 679543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-03-16T23:05:00+02:00", "chargeStopDateTime": "2025-03-17T05:50:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 679210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2025-03-08T10:15:00+02:00", "chargeStopDateTime": "2025-03-08T11:05:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 36, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 77.3, "totalDue": 27.83, "netDue": 27.83, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 678876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-02-28T22:30:00+02:00", "chargeStopDateTime": "2025-02-28T05:15:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 678543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2025-02-20T12:20:00+02:00", "chargeStopDateTime": "2025-02-20T13:12:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 37, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 79.6, "totalDue": 28.66, "netDue": 28.66, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 678210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-02-12T23:00:00+02:00", "chargeStopDateTime": "2025-02-13T05:45:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 677876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2025-02-04T09:30:00+02:00", "chargeStopDateTime": "2025-02-04T10:22:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 38, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 81.4, "totalDue": 32.56, "netDue": 32.56, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 677543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-01-27T22:45:00+02:00", "chargeStopDateTime": "2025-01-28T05:30:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 677210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2025-01-19T11:10:00+02:00", "chargeStopDateTime": "2025-01-19T12:02:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 39, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 82.7, "totalDue": 33.08, "netDue": 33.08, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 676876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2025-01-11T23:10:00+02:00", "chargeStopDateTime": "2025-01-12T05:55:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 676543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2025-01-03T10:40:00+02:00", "chargeStopDateTime": "2025-01-03T11:32:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 40, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 80.9, "totalDue": 32.36, "netDue": 32.36, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 676210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-12-26T22:25:00+02:00", "chargeStopDateTime": "2024-12-27T05:10:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 675876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2024-12-18T12:05:00+02:00", "chargeStopDateTime": "2024-12-18T12:57:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 41, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 78.5, "totalDue": 31.40, "netDue": 31.40, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 675543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-12-10T23:00:00+02:00", "chargeStopDateTime": "2024-12-11T05:45:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 675210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2024-12-02T09:15:00+02:00", "chargeStopDateTime": "2024-12-02T10:08:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 42, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.40, "usageBase": 76.2, "totalDue": 30.48, "netDue": 30.48, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 674876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-11-24T22:40:00+02:00", "chargeStopDateTime": "2024-11-25T05:25:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 674543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2024-11-16T11:30:00+02:00", "chargeStopDateTime": "2024-11-16T12:22:00+02:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 43, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 74.1, "totalDue": 28.16, "netDue": 28.16, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 674210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-11-08T23:05:00+02:00", "chargeStopDateTime": "2024-11-09T05:50:00+02:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 673876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2024-10-31T10:20:00+03:00", "chargeStopDateTime": "2024-10-31T11:12:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 44, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 69.8, "totalDue": 26.52, "netDue": 26.52, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 673543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-10-23T22:15:00+03:00", "chargeStopDateTime": "2024-10-24T05:00:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 673210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2024-10-15T12:45:00+03:00", "chargeStopDateTime": "2024-10-15T13:35:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 45, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 71.6, "totalDue": 27.21, "netDue": 27.21, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 672876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-10-07T23:20:00+03:00", "chargeStopDateTime": "2024-10-08T06:05:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 672543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2024-09-29T09:55:00+03:00", "chargeStopDateTime": "2024-09-29T10:45:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 46, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 73.4, "totalDue": 27.89, "netDue": 27.89, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 672210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-09-21T22:30:00+03:00", "chargeStopDateTime": "2024-09-22T05:15:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 671876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2024-09-13T11:00:00+03:00", "chargeStopDateTime": "2024-09-13T11:50:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 47, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.38, "usageBase": 65.9, "totalDue": 25.04, "netDue": 25.04, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 671543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-09-05T23:00:00+03:00", "chargeStopDateTime": "2024-09-06T05:45:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 671210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Espoo Sello", "chargeStartDateTime": "2024-08-28T10:30:00+03:00", "chargeStopDateTime": "2024-08-28T11:20:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 48, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 61.5, "totalDue": 22.14, "netDue": 22.14, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 670876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-08-20T22:50:00+03:00", "chargeStopDateTime": "2024-08-21T05:35:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 670543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Helsinki Itäkeskus", "chargeStartDateTime": "2024-08-12T09:20:00+03:00", "chargeStopDateTime": "2024-08-12T10:10:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 49, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 58.7, "totalDue": 21.13, "netDue": 21.13, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 670210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-08-04T23:10:00+03:00", "chargeStopDateTime": "2024-08-05T05:55:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 669876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Tampere Koskikeskus", "chargeStartDateTime": "2024-07-27T12:15:00+03:00", "chargeStopDateTime": "2024-07-27T13:05:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 50, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 64.2, "totalDue": 23.11, "netDue": 23.11, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 669543210, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-07-19T22:40:00+03:00", "chargeStopDateTime": "2024-07-20T05:25:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] },
    { "sessionId": 669210876, "vin": "5YJSA1E18MF555555", "siteLocationName": "Tesla Supercharger Turku Skanssi", "chargeStartDateTime": "2024-07-11T11:50:00+03:00", "chargeStopDateTime": "2024-07-11T12:40:00+03:00", "countryCode": "FI", "billingType": "PAYMENT", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [{ "sessionFeeId": 51, "feeType": "CHARGING", "currencyCode": "EUR", "pricingType": "PER_KWH", "rateBase": 0.36, "usageBase": 62.8, "totalDue": 22.61, "netDue": 22.61, "uom": "kwh", "isPaid": true, "status": "PAID" }] },
    { "sessionId": 668876543, "vin": "5YJSA1E18MF555555", "siteLocationName": "Home - Helsinki", "chargeStartDateTime": "2024-07-03T23:00:00+03:00", "chargeStopDateTime": "2024-07-04T05:45:00+03:00", "countryCode": "FI", "billingType": "FREE", "vehicleMakeType": "tesla_model_s", "invoices": [], "fees": [] }
  ]
}
};
